import { RespondersHomeService } from '../../../../../rms/app/responders/responders-home/shared/services/responders-home.service';
import { Injectable, Injector } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { NdmsResolverService } from '../../../../../shared/core/interfaces/ndmsResolverService';
import { ResponderService } from '../../../../../rms/app/api/services/responder.service';
import { ServiceLocator } from '../../../../../shared/core/services/locator.service';
import {AuthApiService} from "./auth.service";

@Injectable()
export class AuthenticationGuard implements Resolve<any> {

  constructor(private injector: Injector) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any> | Promise<any> {
    const authApiService: AuthApiService = this.injector.get(AuthApiService);

    /*if(!authApiService.hasAuthenticated() ){
      authApiService.initiateLoginFlow();
      return Observable.empty();
    }*/
    return true;
  }

}
